import React from 'react';
import { useStores, getContext, initContext } from 'src/store';
import { TChartProps } from 'src/types';
import Chart from './Chart';

const SmartChart = React.forwardRef(({ children, ...props }: TChartProps, ref) => {
    const is_context_intialized = React.useRef(false);
    if (!is_context_intialized.current) {
        initContext();
        is_context_intialized.current = true;
    }

    const store = useStores();
    const context = getContext();

    const Provider = context.Provider;

    React.useEffect(() => {
        const onWindowError = (e: ErrorEvent) => {
            // eslint-disable-next-line no-console
            console.error('[SmartChart] Global error', {
                message: e.message,
                filename: e.filename,
                lineno: e.lineno,
                colno: e.colno,
                activeSymbol: store.chart.currentActiveSymbol?.symbol,
                granularity: store.state.granularity,
            });
        };
        const onUnhandled = (e: PromiseRejectionEvent) => {
            // eslint-disable-next-line no-console
            console.error('[SmartChart] Unhandled rejection', e.reason);
        };
        window.addEventListener('error', onWindowError);
        window.addEventListener('unhandledrejection', onUnhandled);
        return () => {
            window.removeEventListener('error', onWindowError);
            window.removeEventListener('unhandledrejection', onUnhandled);
        };
    }, [store.chart.currentActiveSymbol, store.state.granularity]);

    return (
        <Provider value={store}>
            <Chart {...props} ref={ref}>
                {children}
            </Chart>
        </Provider>
    );
});

export default SmartChart;
